import { cache } from '@/container/apollo-client/cache';
import { CURSOR_MESSAGES } from '@/graphql/cursor.graphql';
import { MessageConversationSubscription, MessageConversationsV2Query } from '@/types/generated/graphql';

export function messageConversationHandler(data: MessageConversationSubscription) {
  const cachedMessages = cache.readQuery<MessageConversationsV2Query>({
    query: CURSOR_MESSAGES,
    variables: {
      clientId: data?.messageConversation?.client?.id,
      channelId: data?.messageConversation?.channelId,
    },
  });
  // need to check this condition because in case of primary sender among groups, it would be already appended
  const alreadyAppendedToCache = cachedMessages?.messageConversationsV2?.data?.find(
    (message) => message?.id === data?.messageConversation?.id
  );

  if (alreadyAppendedToCache) {
    return;
  }

  cache.updateQuery(
    {
      query: CURSOR_MESSAGES,
      variables: {
        clientId: data?.messageConversation?.client?.id,
        channelId: data?.messageConversation?.channelId,
      },
    },
    (cachedData) => {
      return {
        ...cachedData,
        messageConversationsV2: {
          ...cachedData?.messageConversationsV2,
          data: [data?.messageConversation, ...(cachedData?.messageConversationsV2?.data || [])],
        },
      };
    }
  );
}
